import http from '@/http-common'
import Tab from '@/components/TabSpr.vue'
import InputGroupForm from '@/components/InputGroupForm.vue'
import Title from '@/components/TitlePage'

export default {
  name: "LoggingForm",
  components: {Tab, InputGroupForm, Title},
  data() {
    return {
      items: [],
      isBusy: false,
      columns: [
        {key: 'selected', label: 'Выбрано'},
        {key: 'cDate', label: 'Дата'},
        {key: 'comment', label: 'Комментарий'},
        {key: 'ekpData.nameEvent', label: 'Подробные данные'},
        {key: 'statusRequest', label: 'Статус'},
        {key: 'userU', label: 'Пользователь'},
        {key: 'actions', label: 'Детали'}
      ],
      urls: {
        save: '',
        delete: '',
      },
      captionSpr: {
        name: '',
        nameR: ''
      },
      selectMode: 'range',
      heightTab: "80vh",
      filterLog: {
        dat1: null,
        dat2: null,
        nameEvent: ''
      },
      currentPage: 1,
      perPage: 10,
      totalSize: 0,
      selected: new Set([]),
      selectedGlobal: new Set([]),
      dfileName: 'Выгрузка для приказов.xls',
      downloadFileLink: '',
      modalLoadOpened: false
    }
  },
  created() {
    const dat = new Date();
    this.filterLog.dat1 = (dat.getFullYear()).toString() + "-01-01";
    this.filterLog.dat2 = (dat.getFullYear()).toString() + "-12-31";
    this.filterLog.nameEvent = ''
    this.loadItems()
  },
  methods: {
    onRowSelected(items) {
      this.selected = items;
    },
    loadItems() {
      let vm = this;
      this.isBusy = true;
      this.selectedGlobal = new Set([...this.selected, ...this.selectedGlobal])
      http.get('/logging/list?dat1=' + vm.filterLog.dat1 + "&dat2=" + vm.filterLog.dat2 +
          "&nameEvent=" + vm.filterLog.nameEvent +
          "&pageNum=" + (vm.currentPage - 1) + "&pageSize=" + vm.perPage)
      .then((response) => {
        vm.items = response.data.obj;
        vm.totalSize = response.data.size;
      })
      .catch((error) => console.log(error.message))
      .finally(() => {
            vm.isBusy = false;
            vm.selectFromGlobal()
          }
      );
    },
    showEditDialog() {

    },
    selectFromGlobal() {
      this.selectedGlobal.forEach(x => {
        const index = this.items.findIndex(item => item.id === x.id);
        if (index >= 0) {
          this.$refs.loggingTab.selectRow(index)
        }
      })
    },
    checkDate() {
      let vm = this;
      if (vm.filterLog.dat1 > vm.filterLog.dat2) {
        vm.filterLog.dat2 = vm.filterLog.dat1
      }
    },
    clearSelected() {
      this.$refs.loggingTab.clearSelected()
      this.selectedGlobal = new Set([])
    },
    exportForOrder() {
      let vm = this;
      this.downloadFileLink = '';
      this.selectedGlobal = new Set([...this.selected, ...this.selectedGlobal])
      if (this.selectedGlobal && this.selectedGlobal.size > 0) {
        this.selectedGlobal.forEach(x => {
          x.uDate = new Date(x.uDate);
          x.cDate = new Date(x.cDate);
        });
        http.post('/logging/forOrder', Array.from(vm.selectedGlobal))
        .then(response => {
          if (response.data.ok || response.data.name !== '') {
            this.downloadFileLink = '/report/download?name=' + encodeURIComponent(response.data.name);
            this.dfileName = 'Выгрузка для приказов.xls';
            vm.downloadFile();
            vm.clearSelected()
          } else {
            alert("Отчет не сформирован!");
          }
        })
        .catch((error) => console.log(error.response.data))
      } else {
        console.log("Отчет пустой!");
      }
    },
    downloadFile() {
      var vm = this;
      this.modalLoadOpened = true;
      http.get(this.downloadFileLink,
          {
            responseType: 'arraybuffer',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/pdf'
            }
          }
      ).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', vm.dfileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      }).finally(() => vm.modalLoadOpened = false);
    },
    formatDate(cDate) {
      const date = new Date(cDate);

      // Форматируем локально и заменяем разделители
      const formatted = date.toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      // Преобразуем "24/12/2025, 08:58:45" в "24-12-2025 08:58:45"
      return formatted.replace(/(\d{2})\/(\d{2})\/(\d{4}), (\d{2}:\d{2}:\d{2})/, '$1-$2-$3 $4');
    }
  }
}
